import { render, staticRenderFns } from "./AtlasLogo.vue?vue&type=template&id=74b42c68&scoped=true&"
var script = {}
import style0 from "./AtlasLogo.vue?vue&type=style&index=0&id=74b42c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b42c68",
  null
  
)

export default component.exports